module.exports = __webpack_public_path__ + "media/images/flags/64/Commonwealth-c053f590db5dd394aa77e3beafd97dbc.png";